export const Newsletter = () => (
  <div className="mt-0" />
);
